import User from '@client/User'
import Guest from '@client/Guest'
import Order from '@client/Order'

export const createUser = (): User => {
	return new User(undefined, undefined, undefined, undefined)
}

export const createGuest = (): Guest => {
	return new Guest(
		undefined,
		undefined,
		undefined,
		undefined,
		undefined,
		undefined,
	)
}

export const createOrder = (): Order => {
	return new Order(undefined, undefined, undefined, undefined, [])
}
